import { getViewportForBounds, Rect, Viewport } from "@xyflow/react";
import { getAbsoluteNodeRects } from "../ownershipEdgeRouting.helpers";
import { OwnershipFlowNode } from "../ownership.types";

const FIT_VIEW_PADDING = 0.2;
const FIT_VIEW_MAX_ZOOM = 1;
export const OWNERSHIP_COMMAND_BAR_FOOTPRINT = 80;

interface GetOwnershipFitViewportParams {
    bounds: Rect;
    width: number;
    height: number;
    minZoom: number;
}

export function getOwnershipGraphBounds(
    nodes: OwnershipFlowNode[],
): Rect | null {
    if (nodes.length === 0) {
        return null;
    }
    let minX = Infinity;
    let minY = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;
    for (const rect of getAbsoluteNodeRects(nodes).values()) {
        minX = Math.min(minX, rect.x);
        minY = Math.min(minY, rect.y);
        maxX = Math.max(maxX, rect.x + rect.width);
        maxY = Math.max(maxY, rect.y + rect.height);
    }
    return { x: minX, y: minY, width: maxX - minX, height: maxY - minY };
}

export function getOwnershipFitViewport({
    bounds,
    width,
    height,
    minZoom,
}: GetOwnershipFitViewportParams): Viewport {
    return getViewportForBounds(
        bounds,
        width,
        Math.max(height - OWNERSHIP_COMMAND_BAR_FOOTPRINT, 0),
        minZoom,
        FIT_VIEW_MAX_ZOOM,
        FIT_VIEW_PADDING,
    );
}
